import React from 'react'
import './Divider.sass'

export const Divider = () => {
  return <span className='divider'></span>
}
